import {
  // SHIPMENTS
  FETCH_SHIPMENTS,
  FETCH_SHIPMENT,
  CREATE_SHIPMENT,
  UPDATE_SHIPMENT,
  FETCH_DESTINATIONS,
  // PACKAGES
  FETCH_PACKAGE_TYPES,
  CREATE_PACKAGE,
  DELETE_PACKAGE,
  ADD_PACKAGE_TO_STATE,
  DELETE_PACKAGE_FROM_STATE,
  ADD_ITEM_TO_PACKAGE,
  DELETE_ITEM_FROM_PACKAGE,
  // RETURNS
  CREATE_RETURN,
  FETCH_RETURN,
  FETCH_RETURNS,
  FETCH_RETURN_CATEGORIES,
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_SHIPMENTS
// --------------------------------------------------------------------------
export const fetchShipments = (page, shipmentId, itemName, shipmentDate, shipmentCustomer) => ({
  type: FETCH_SHIPMENTS.init,
  payload: API.fetchShipments(page, shipmentId, itemName, shipmentDate, shipmentCustomer),
});

export const fetchShipmentsSuccess = (info) => ({
  type: FETCH_SHIPMENTS.success,
  payload: info,
});

export const fetchShipmentsFailure = (error) => ({
  type: FETCH_SHIPMENTS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_SHIPMENT
// --------------------------------------------------------------------------
export const fetchShipment = (id) => ({
  type: FETCH_SHIPMENT.init,
  payload: API.fetchShipment(id),
});

export const fetchShipmentSuccess = (data) => ({
  type: FETCH_SHIPMENT.success,
  payload: data,
});

export const fetchShipmentFailure = (error) => ({
  type: FETCH_SHIPMENT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_SHIPMENT
// --------------------------------------------------------------------------
export const createShipment = (data) => ({
  type: CREATE_SHIPMENT.init,
  payload: API.createShipment(data),
});

export const createShipmentSuccess = (data) => ({
  type: CREATE_SHIPMENT.success,
  payload: data,
});

export const createShipmentFailure = (error) => ({
  type: CREATE_SHIPMENT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UPDATE_SHIPMENT
// --------------------------------------------------------------------------
export const updateShipment = (id, data) => ({
  type: UPDATE_SHIPMENT.init,
  payload: API.updateShipment(id, data),
});

export const updateShipmentSuccess = (info) => ({
  type: UPDATE_SHIPMENT.success,
  payload: info,
});

export const updateShipmentFailure = (error) => ({
  type: UPDATE_SHIPMENT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_DESTINATIONS
// --------------------------------------------------------------------------
export const fetchDestinations = () => ({
  type: FETCH_DESTINATIONS.init,
  payload: API.fetchDestinations(),
});

export const fetchDestinationsSuccess = (data) => ({
  type: FETCH_DESTINATIONS.success,
  payload: data,
});

export const fetchDestinationsFailure = (error) => ({
  type: FETCH_DESTINATIONS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_PACKAGE_TYPES
// --------------------------------------------------------------------------
export const fetchPackageTypes = () => ({
  type: FETCH_PACKAGE_TYPES.init,
  payload: API.fetchPackageTypes(),
});

export const fetchPackageTypesSuccess = (data) => ({
  type: FETCH_PACKAGE_TYPES.success,
  payload: data,
});

export const fetchPackageTypesFailure = (error) => ({
  type: FETCH_PACKAGE_TYPES.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_PACKAGE
// --------------------------------------------------------------------------
export const createPackage = (data) => ({
  type: CREATE_PACKAGE.init,
  payload: API.createPackage(data),
});

export const createPackageSuccess = (data) => ({
  type: CREATE_PACKAGE.success,
  payload: data,
});

export const createPackageFailure = (error) => ({
  type: CREATE_PACKAGE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// DELETE_PACKAGE
// --------------------------------------------------------------------------
export const deletePackage = (id) => ({
  type: DELETE_PACKAGE.init,
  payload: API.deletePackage(id),
});

export const deletePackageSuccess = (data) => ({
  type: DELETE_PACKAGE.success,
  payload: data,
});

export const deletePackageFailure = (error) => ({
  type: DELETE_PACKAGE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// ADD_PACKAGE_TO_STATE
// --------------------------------------------------------------------------
export const addPackageToState = (data) => ({
  type: ADD_PACKAGE_TO_STATE,
  payload: data,
});

// --------------------------------------------------------------------------
// DELETE_PACKAGE_FROM_STATE
// --------------------------------------------------------------------------
export const deletePackageFromState = (data) => ({
  type: DELETE_PACKAGE_FROM_STATE,
  payload: data,
});

// --------------------------------------------------------------------------
// ADD_ITEM_TO_PACKAGE
// --------------------------------------------------------------------------
export const addItemToPackage = (packageId, items) => ({
  type: ADD_ITEM_TO_PACKAGE,
  payload: { packageId, items },
});

// --------------------------------------------------------------------------
// DELETE_ITEM_FROM_PACKAGE
// --------------------------------------------------------------------------
export const deleteItemFromPackage = (packageId, itemID) => ({
  type: DELETE_ITEM_FROM_PACKAGE,
  payload: { packageId, itemID },
});

// --------------------------------------------------------------------------
// CREATE_RETURN
// --------------------------------------------------------------------------
export const createReturn = (data) => ({
  type: CREATE_RETURN.init,
  payload: API.createReturn(data),
});

export const createReturnSuccess = (data) => ({
  type: CREATE_RETURN.success,
  payload: data,
});

export const createReturnFailure = (error) => ({
  type: CREATE_RETURN.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_RETURN
// --------------------------------------------------------------------------
export const fetchReturn = (id) => ({
  type: FETCH_RETURN.init,
  payload: API.fetchReturn(id),
});

export const fetchReturnSuccess = (data) => ({
  type: FETCH_RETURN.success,
  payload: data,
});

export const fetchReturnFailure = (error) => ({
  type: FETCH_RETURN.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_RETURNS
// --------------------------------------------------------------------------
export const fetchReturns = (page, returnId, shipmentId, returnDate, customer) => ({
  type: FETCH_RETURNS.init,
  payload: API.fetchReturns(page, returnId, shipmentId, returnDate, customer),
});

export const fetchReturnsSuccess = (data) => ({
  type: FETCH_RETURNS.success,
  payload: data,
});

export const fetchReturnsFailure = (error) => ({
  type: FETCH_RETURNS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_RETURN_CATEGORIES
// --------------------------------------------------------------------------
export const fetchReturnCategories = () => ({
  type: FETCH_RETURN_CATEGORIES.init,
  payload: API.fetchReturnCategories(),
});

export const fetchReturnCategoriesSuccess = (data) => ({
  type: FETCH_RETURN_CATEGORIES.success,
  payload: data,
});

export const fetchReturnCategoriesFailure = (error) => ({
  type: FETCH_RETURN_CATEGORIES.failure,
  payload: error,
});

// ---------------------------------------------------------------------------
// CREATE_SHIPMENT (MARKET ORDER)
// ---------------------------------------------------------------------------
export const createShipmentForOrder = (orderId) => ({
  type: CREATE_SHIPMENT.init,
  payload: API.createShipmentForOrder(orderId),
});

export const createShipmentForOrderSuccess = (info) => ({
  type: CREATE_SHIPMENT.success,
  payload: info,
});

export const createShipmentForOrderFailure = (error) => ({
  type: CREATE_SHIPMENT.failure,
  payload: error,
});
